















































































































































































































































































































































































































































































































































































































import store from "@/store";
import { SelectionNotificationReceiver } from "@/service/SelectionNotificationReceiver";
import { Component, Vue, Watch } from "vue-property-decorator";
import { Getter, Action } from "vuex-class";
import { InspectButtonValue } from "@/model/InspectButtonValue";
import {
  AssignmentWork,
  WorkItem,
  WorkBuhin,
  SeibiStaff
} from "@/model/AssignmentWork";
import InputNumber from "@/components/common/input/InputNumber.vue";
import EstimateInspectionCostComponent from "@/components/EstimateInspectionCostComponent.vue";
import QuickInspectionCostComponent from "@/components/QuickInspectionCostComponent.vue";
import QuickInspectListComponent from "@/components/QuickInspectListComponent.vue";
import QuickMitsumoriContentPreview from "@/components/QuickMitsumoriContentPreview.vue";
import QuickCouponComponent from "@/components/QuickCouponComponent.vue";
import QuickOptionComponent from "@/components/QuickOptionComponent.vue";
import QuickOptionComponentNex from "@/components/QuickOptionComponentNex.vue";
import EstimateListComponent from "@/components/EstimateListComponent.vue";
import EstimatePreview from "@/components/EstimatePreview.vue";
import Number from "@/shared/filters/Number";
import InputString from "@/components/common/input/InputString.vue";
import { INSPECT_TYPE } from "@/model/InspectType";
import requestService from "@/service/requestService";
import loadingService from "@/service/loadingService";
import { NAVIGATION_STATUS } from "@/model/NavigationStatus";
/** 2021-08-18 sh #7350 if change estimate at User screen, re-get jizen mitsumori. [START] */
import { MESSAGE } from "@/model/Message";
/** 2021-08-18 sh #7350 if change estimate at User screen, re-get jizen mitsumori. [END] */
import ConfirmDialog from "@/components/common/ConfirmDialog.vue";
/** 2021-09-07 sh #7391 implements socket for option and coupon. [START] */
import { UserService } from "@/service/UserService";
import { SocketControllers } from "@/service/SocketControllers";
/** 2021-09-07 sh #7391 implements socket for option and coupon. [END] */
import * as util from "@/service/util";
import vuedraggable from "vuedraggable";
import { InspectService } from "@/service/inspectService";
import { IppanSeibiService } from "@/service/IppanSeibiService";
import NextageFooter from "@/components/nextageFooter.vue";
import ExtendsImageDialog from "@/components/ExtendsImageDialog.vue";
import { ExtendsImageService } from "@/service/ExtendsImageService";
import { ExtendsImageInspectVO } from "@/model/ExtendsImage";
import { Utils } from "@/service/util";

@Component({
  components: {
    InputNumber,
    InputString,
    EstimateInspectionCostComponent,
    QuickInspectionCostComponent,
    QuickInspectListComponent,
    QuickMitsumoriContentPreview,
    QuickCouponComponent,
    QuickOptionComponent,
    QuickOptionComponentNex,
    EstimateListComponent,
    EstimatePreview
    , ConfirmDialog
    , draggable: vuedraggable
    , NextageFooter
    , ExtendsImageDialog
  },
  filters: { Number }
})
export default class EstimateDetail extends Vue {

  isModeTab: boolean = false;
  isModeQuick: boolean = false;

  $refs!: {
    estimateInspectionCostComponent: EstimateInspectionCostComponent;
    quickInspectionCostComponent: QuickInspectionCostComponent;
    quickCouponComponent: QuickCouponComponent;
    quickOptionComponent: QuickOptionComponent;
    quickOptionComponentNex: QuickOptionComponent;
    estimateListComponent: EstimateListComponent;
    dialog: ConfirmDialog;
    confirmDialogOnlyClose: ConfirmDialog;
    updateShakenShuruiDialog: ConfirmDialog;
    saveAndExitDialog: ConfirmDialog;
  };

  listPrefectures: any = {};

  isUserMode = false;
  seibiList: any = [];
  companyInfo: any = {};

  inspectType: number = INSPECT_TYPE.RECOMMEND;

  showDialogInspectionCost: boolean = false;
  showDialogCoupon: boolean = false;
  showDialogEstimate: boolean = false;
  showDialogPreview: boolean = false;
  showDialogOption: boolean = false;

  loading: boolean = false;
  loadingText: string = MESSAGE.Loading;
  data: any = {};
  estData: any = {};
  estIssueAt: string = "";

  execAfOpenShowTax: boolean = false;
  execAfOpenUpdateShohiyou: boolean = false;
  execAfOpenUpdateEstimate: boolean = false;

  workData: AssignmentWork = {};

  isExitConnectSocket: boolean = false;

  public reqService: requestService = new requestService();
  public sktControll: SocketControllers;
  loadingService: loadingService = new loadingService();
  inspectService: InspectService = new InspectService();
  ippanSeibiService: IppanSeibiService = new IppanSeibiService();
  public utils: Utils = new Utils();

  @Getter("uketsukeExtendsId", { namespace: "ReservationDetail" })
  uketsukeExtendsId: number;

  /** 2021-08-18 sh #7350 if change estimate at User screen, re-get jizen mitsumori. [START] */
  @Getter("uketsukeCd", { namespace: "ReservationDetail" })
  uketsukeCd: string;
  @Getter("yoyakuNo", { namespace: "ReservationDetail" })
  yoyakuNo: string;
  /** 2021-08-18 sh #7350 if change estimate at User screen, re-get jizen mitsumori. [END] */

  /** 2023-10-19 invoice [START] */
  @Getter("isExcludingTax", { namespace: "FunctionSetting" })
  isExcludingTax: any;
  @Getter("taxLabel", { namespace: "FunctionSetting" })
  taxLabel: string;
  @Getter("couponLabel", { namespace: "FunctionSetting" })
  couponLabel: string;
  @Getter("optionLabel", { namespace: "FunctionSetting" })
  optionLabel: string;
  /** 2023-10-19 invoice [END] */
  /** 2024-05-02 nextage [START] */
  @Getter("isNextageCustom", { namespace: "FunctionSetting" })
  isNextageCustom: any;
  /** 2024-05-02 nextage [END] */
  @Getter("isEstimateBuhin", { namespace: "FunctionSetting" })
  isEstimateBuhin: any;
  @Getter("isCanExtendsImage", { namespace: "FunctionSetting" })
  isCanExtendsImage: any;

  /** 2022-03-16 sh #7780(BQR807-17) add check ryoukin-rank. [START] */
  @Getter("currentState", { namespace: "ReservationDetail" })
  reservationDetail: any;

  @Getter("freeOfChargeLabelMini", { namespace: "FunctionSetting" })
  freeOfChargeLabel: any;

  @Getter("isConfirm", { namespace: "Option" })
  isConfirmOption: any;
  @Getter("waitingAutoSave", { namespace: "Option" })
  waitingAutoSaveOption: any;
  @Getter("isConfirm", { namespace: "Coupon" })
  isConfirmCoupon: any;
  @Getter("waitingAutoSave", { namespace: "Coupon" })
  waitingAutoSaveCoupon: any;

  @Getter("isUseIppanSeibi", { namespace: "FunctionSetting" })
  isUseIppanSeibi: boolean | null; // システム設定A 一般整備見積
  @Getter("isEstimateAssignment", { namespace: "FunctionSetting" })
  isEstimateAssignment: boolean | null; // システム設定E 事前見積でextreme取込

  confirmDialogMsg: string = '';
  /** 2022-03-16 sh #7780(BQR807-17) add check ryoukin-rank. [END] */
  /** 2023-03-30 sh #8188(BQR1084) course does not work for recommend. [START] */
  timeId: any = null;
  /** 2023-03-30 sh #8188(BQR1084) course does not work for recommend. [END] */

  extendsImageService: ExtendsImageService = new ExtendsImageService();
  extendsImageInspectMap: {[sknUketsukeInspectId: number]: ExtendsImageInspectVO} | null = null;
  extendsImageWorkList: ExtendsImageInspectVO[] | null = null;
  extendsImageWorkListIndex: number = -1;
  showExtendsImageDialog: boolean = false;

  /*
   * 初期化関数
   * ( createdやmountedで1回だけ実行される必要があるが
   *   特定のパラメータが足りない時は実行順序を前後させる必要がある処理 )
   */
  @Watch("uketsukeCd")
  connectSocket() {
    // 必要な値が未セット、または初期化済みなら何もしない
    if (!this.uketsukeCd || this.isExitConnectSocket) { return; }
    this.isExitConnectSocket = true;

    this.sktControll = new SocketControllers(this);
    this.sktControll.onReconnect(() => this.selectionReceiver.receive());
    /** やりたいことは、再読込なので、流用する */
    this.sktControll.socketEntry("estimateListSubscription",this.execOnPayments); // catchSocket:ソケット仮01
    this.sktControll.socketEntry("ak7Subscribe",this.onPayments); // catchSocket:ソケット仮34

    // ポップアップ上で変更があった場合に、再読み込みを行う
    this.sktControll.socketEntry("doTenkenSubscribe",this.onPayments); // catchSocket:13するしない後日編集

    // catchSocket:17車検検査費用と車検基本費用の編集
    this.sktControll.socketEntry("kensaHiyouSubscription",this.onPayments, true);

    this.sktControll.socketEntry("shohiyouSubscriptionComp",this.onPayments, true); // catchSocket:15車検諸費用の編集
    this.sktControll.socketEntry("optionSubscription",this.onSelectionChanged); // catchSocket:ソケット仮12
    this.sktControll.socketEntry("couponSubscription",this.onSelectionChanged); // catchSocket:ソケット仮11
    this.sktControll.socketEntry("inspectSeibiSubscribe",this.onPayments); // catchSocket:ソケット仮06

    // catchSocket:08車検コース変更による再描画指示
    this.sktControll.socketEntry("updateCourseSubscription", (frame: any) => this.onSelectionChanged(frame, true));
    this.sktControll.socketEntry("inspectSubscriptionDetail",this.onSelectionChanged);
    this.sktControll.connectSocket();
  }

  created() {
    this.isUserMode = this.$route.meta === "user";
    this.$emit("onactivepage", this.$route.name);
    this.getCompanyInfo();
    this.getJizenMitsumoriPreview();
    this.$nextTick(() => {
    this.getJizenResult();
    });
    this.getJizenInspectionSeibi();
    this.connectSocket();
    this.createdExtends();
  }

  mounted() {
    this.mountedExtends();
  }

  createdExtends() {
    this.onUpdateCoupon();
    this.onUpdateOption();
    // ライフサイクルフックはExtendsの両方で動作するので
    // 別の動作が必要な部分はここで処理を行う
  }

  mountedExtends() {
    // ライフサイクルフックはExtendsの両方で動作するので
    // 別の動作が必要な部分はここで処理を行う
    /** 2022-03-16 sh #7780(BQR807-17) add check ryoukin-rank. [START] */
    /** 料金ランクが設定済みかチェックする。NGの場合、税金情報のダイアログを開いてさらに小窓を開く。 */
    if (this.isValidRyoukinRank()) {
      this.getJizenMitsumoriPreview(); // createdで実行済み
    } else {
      this.execAfOpenShowTax = true; // 小窓展開を予約
      this.showDialogInspectionCost = true;
    }
    /** 2022-03-16 sh #7780(BQR807-17) add check ryoukin-rank. [END] */

    // EstimateDetailContent.vue の場合に動かないよう、createdではなくmountedで実行する
    // （顧客詳細画面でソケットが2重に接続される問題対策）
    this.getExtendsImageInspectMap(); 
  }

  showDialogInspectionCostOpened() {
    // 車検費用モーダルの初回呼出表示までにrefしていた内容は実行されないのでここで処理する
    if (this.execAfOpenShowTax) {
      this.$refs.estimateInspectionCostComponent.showTaxDialog();
      this.execAfOpenShowTax = false;
    }
    if ( this.execAfOpenUpdateShohiyou 
      && typeof this.$refs.estimateInspectionCostComponent.onUpdateShohiyou === 'function' ) {
      this.$refs.estimateInspectionCostComponent.onUpdateShohiyou();
      this.execAfOpenUpdateShohiyou = false;
    }
  }

  showDialogOptionOpened() {
    // モーダルを閉じているときに別セッションで更新された内容が反映されないので
    // 画面を開いたら確認させる
    this.$refs.quickOptionComponent.onCheckChange();
  }

  showDialogCouponOpened() {
    // モーダルを閉じているときに別セッションで更新された内容が反映されないので
    // 画面を開いたら確認させる
    this.$refs.quickOptionComponent.onCheckChange();
  }

  showDialogEstimateListOpened() {
    // おすすめ整備モーダルの初回呼出表示までにrefしていた内容は実行されないのでここで処理する
    if ( this.execAfOpenUpdateEstimate 
      && typeof this.$refs.estimateListComponent.updateCurrentData === 'function') {
      this.$refs.estimateListComponent.updateCurrentData();
      this.execAfOpenUpdateEstimate= true;
    }
  }

  getJizenMitsumoriPreview() {
    this.reqService.getJizenMitsumoriPreview(this.uketsukeExtendsId).then(
      (res: any) => {
        let shakenHiyouKazeiItem = [];
        let shakenHiyouHikazeiItem = [];
        // ネクステージ版では課税区分で分岐。通常は全部課税用のエリアに表示する
        if (res.shakenHiyouItems) {
          shakenHiyouKazeiItem = res.shakenHiyouItems.filter((item: any, index: number) => {
            return index === res.shakenHiyouItems.findIndex((obj: any) => {
              return item.shohiyouCd == obj.shohiyouCd && item.shohiyouNm == obj.shohiyouNm;
            }) && item.shohiyouNm != '' 
            && ( !this.isNextageCustom || ( this.isNextageCustom && item.kazeiKbn == '1' ) );
          });
          shakenHiyouHikazeiItem = res.shakenHiyouItems.filter((item: any, index: number) => {
            return index === res.shakenHiyouItems.findIndex((obj: any) => {
              return item.shohiyouCd == obj.shohiyouCd && item.shohiyouNm == obj.shohiyouNm;
            }) && item.shohiyouNm != '' && this.isNextageCustom && item.kazeiKbn == '2';
          });
        }
        res.shakenHiyouKazeiItems = shakenHiyouKazeiItem;
        res.shakenHiyouHikazeiItems = shakenHiyouHikazeiItem;
        /*res.shakenHiyouKazeiItems = [];
        res.shakenHiyouHikazeiItems = [];*/
        /** 2021-08-23 sh #7361 it updates kensaHiyou after update kensaHiyou. [START] */
        // this.data = res;
        this.$set(this, "data", []);
        this.$set(this, "data", res);
        if (this.$refs.estimateInspectionCostComponent) {
          if ( typeof this.$refs.estimateInspectionCostComponent.onUpdateShohiyou === 'function' ) {
            this.$refs.estimateInspectionCostComponent.onUpdateShohiyou();
          }
        } else {
          this.execAfOpenUpdateShohiyou = true; // 諸費用数値更新を予約
        }
        /** 2021-08-23 sh #7361 it updates kensaHiyou after update kensaHiyou. [END] */

      },
      (err: any) => {
      }
    );
  }

  getJizenResult() {
    /** 2022-11-29 sh #8121(BQR982) get free of charge after change shaken-shurui. (add loading.) [START] */
    this.$set(this, "loading", true);
    /** 2022-11-29 sh #8121(BQR982) get free of charge after change shaken-shurui. (add loading.) [END] */
    this.reqService.getJizenResult(this.uketsukeExtendsId).then(
      (res: any) => {
        this.$set(this, "estIssueAt", res.estIssueAt);
        /** 2021-08-23 sh #7361 it updates kensaHiyou after update kensaHiyou. [START] */
        // this.estData = res.jizenResult;
         this.$set(this, "estData", []);
         this.$set(this, "estData", res.jizenResult);
        /** 2021-08-23 sh #7361 it updates kensaHiyou after update kensaHiyou. [END] */

        /** 2021-11-26 sh #7574 set to currentIndex at estimateList. [START] */
        /** する・しない・後日を押した場合、データを取得しなおしているので、子画面が開いていたら、スクロールさせる */
        if (this.showDialogEstimate) {
          this.$refs.estimateListComponent.scrollToCurrentIndex();
        }
        /** 2021-11-26 sh #7574 set to currentIndex at estimateList. [END] */
        if (this.estData && this.estData.length > 0) {
          if (this.estData[0].osusume) {
            this.inspectType = INSPECT_TYPE.RECOMMEND;
          } else {
            this.inspectType = INSPECT_TYPE.LEGAL56;
          }
          this.setSeibiData();
          /** 2021-08-20 sh #7356  send message to customer-screen. [START] */
          if ( this.$refs.estimateListComponent ) {
            if ( typeof this.$refs.estimateListComponent.updateCurrentData === 'function') {
              this.$refs.estimateListComponent.updateCurrentData();
            }
          } else {
            this.execAfOpenUpdateEstimate= true;
          }
          /** 2021-08-20 sh #7356  send message to customer-screen. [END] */
        }
        /** 2022-11-29 sh #8121(BQR982) get free of charge after change shaken-shurui. (add loading.) [START] */
        this.$set(this, "loading", false);
        /** 2022-11-29 sh #8121(BQR982) get free of charge after change shaken-shurui. (add loading.) [END] */
      },
      (err: any) => {
        /** 2022-11-29 sh #8121(BQR982) get free of charge after change shaken-shurui. (add loading.) [START] */
        this.$set(this, "loading", false);
        /** 2022-11-29 sh #8121(BQR982) get free of charge after change shaken-shurui. (add loading.) [END] */
      }
    );
  }

  tesdt(item: any) {
    console.log("mode",item.buhinListDisp);
    item.buhinListDisp = !item.buhinListDisp;
    this.$forceUpdate();
  }

  getJizenInspectionSeibi() {
    this.reqService.getJizenInspectionSeibi(this.uketsukeExtendsId).then(
      (res: any) => {

        // 部品リスト表示の設定
        let buhinOpen = false; // 表示初期状態で部品リストを表示する( 開:true 閉:false )
        let buhinSkip = true; // 部品リストをBEから取得( 実行:false 省略:true )
        if (this.isEstimateBuhin) { buhinSkip = false; }

        /** 2021-08-23 sh #7361 it updates kensaHiyou after update kensaHiyou. [START] */
        // this.seibiList = res;
        res.map((e: any, index: number) => {
          e.buhinListDisp = buhinOpen;
          e.buhinListLoaded = buhinSkip;
          e.buhinList = [];
          return e;
        });
        this.$set(this, "seibiList", []);
        this.$set(this, "seibiList", res);
        /** 2021-08-23 sh #7361 it updates kensaHiyou after update kensaHiyou. [END] */

        // 部品リストを追加する
        if (this.isEstimateBuhin) {
          this.seibiList.forEach((elm: any) => {
            if ( elm.sknInspectSeibiId != null ) {
              // this.uketsukeExtendsId は e.sknUketsukeExtendsIdで代用可能
              this.reqService.getInspectSeibiAK3_2(this.uketsukeExtendsId, elm.sknInspectSeibiId, 1, 2)
              .then(
                (data: any) => {
                  elm.buhinList = data.buhinList;
                  elm.buhinListLoaded = true;
                  this.$forceUpdate();
                },
                (error: any) => {
                  elm.buhinListLoaded = true;
                  this.$forceUpdate();
                }
              );
            } else if ( elm.sknUketsukeManualSeibiId != null ) {
              // this.uketsukeExtendsId は e.sknUketsukeExtendsIdで代用可能
              this.reqService.getInspectSeibiAK3_2(this.uketsukeExtendsId, elm.sknUketsukeManualSeibiId, 1, 3)
              .then(
                (data: any) => {
                  elm.buhinList = data.buhinList;
                  elm.buhinListLoaded = true;
                  this.$forceUpdate();
                },
                (error: any) => {
                  elm.buhinListLoaded = true;
                  this.$forceUpdate();
                }
              );
            }
          });
        }
      },
      (err: any) => {
        /** 2022-10-19 sh #8066(BQR974) Choose from multiple parts. [START] */
        if (err && err.hasOwnProperty("status") && err.status == 204) {
          this.$set(this, "seibiList", []);
        }
        /** 2022-10-19 sh #8066(BQR974) Choose from multiple parts. [END] */
      }
    );
  }

  sumItem(item: any) {
    /** 2023-10-19 invoice [START] */
    return this.isExcludingTax? 
    (item.buhinEditTotalZn || 0) + ( item.kouchinEditZn || 0) 
    : (item.buhinEditTotalZk || 0) + ( item.kouchinEditZk || 0);
    /** 2023-10-19 invoice [END] */
  }

  isTriangle(item: any) {
    return item.inspectResult == InspectButtonValue.TRIANGLE;
  }

  isCross(item: any) {
    return item.inspectResult == InspectButtonValue.CROSS;
  }

  get dispJibaiseki() {
   return this.data.zeiJibaisekiZk;
  }
  get dispWeightTax() {
   return this.data.zeiWeightTax;
  }
  get dispInshidai() {
   return this.data.zeiInshidaiZk;
  }
  get dispTechInfoAmount() {
   return this.data.zeiTechInfoAmountZk;
  }

  get dispkensaHiyou() {
    return this.data.kensaHiyou;
  }

  dispShakenHiyouList(kazei: boolean) {
    if (this.data.shakenHiyouItems) {
      if (kazei) {
        return this.data.shakenHiyouKazeiItems;
      } else {
        return this.data.shakenHiyouHikazeiItems;
      }
    } else {
      return []; // 空配列
    }
  }

  get calcTotal2() {
    let total = 0;
    this.seibiList.forEach((elm: any) => {
        let itemTotal = this.sumItem(elm);
        total += itemTotal;
    });
    return total;
  }

  get couponKn() {
    if (this.isExcludingTax) {
      return this.data.couponZn;
    } else {
      return this.data.couponZk;
    }
  }

  get optionKn() {
    if (this.isExcludingTax) {
      return this.data.optionZn;
    } else {
      return this.data.optionZk;
    }
  }

  onShowDialogInspectionCost() {
    this.showDialogInspectionCost = true;
  }

  onShowDialogCoupon() {
    /** 2024-09-26 ネクステージ用調整値引額機能の工場側動作補助 [START] */
    // 調整値引額の基準金額はユーザー側機能で共通化しているが、
    // 工場側では金額系が個別実装で必要な情報のロードを行わないので最新でない場合がある
    
    // 条件：ネクステージで工場側の動作で表示しており、合計金額が違う状態でクーポンをモーダル呼び出しする時
    // モーダル呼び出し関数内でチェックスキップ。合計金額の誤差チェックは税込表示時に時間がかかるので未実装
    if ( !this.isUserMode && this.isNextageCustom ) {
      const userService = new UserService();
      userService.getAllData();
    }
    /** 2024-09-26 ネクステージ用調整値引額機能の工場側動作補助 [END] */
    this.showDialogCoupon = true;
  }

  onShowDialogEstimate() {
    this.showDialogEstimate = true;
  }

  setSeibiData() {
    this.estData.forEach((element: any) => {
      if (element.osusume) {
        if (element.recommend && element.recommend.length > 0) {
          element.recommend.forEach((sub: any) => {
            if (sub.subItems && sub.subItems.length > 0) {
              sub.subItems.forEach((item: any) => {
                if (item.buhinEditTotalZn == null) {
                  item.buhinEditTotalZn = item.buhinZn;
                }
                if (item.buhinEditTotalZk == null) {
                  item.buhinEditTotalZk = item.buhinZk;
                }
                if (item.kouchinEditZn == null) {
                  item.kouchinEditZn = item.kouchinZn;
                }
                if (item.kouchinEditZk == null) {
                  item.kouchinEditZk = item.kouchinZk;
                }
                item.totalZk = item.buhinEditTotalZk + item.kouchinEditZk;
                item.totalZn = item.buhinEditTotalZn + item.kouchinEditZn;
              });
            }
          });
        }
      } else {
        if (element.subItems && element.subItems.length > 0) {
          element.subItems.forEach((sub: any) => {
            if (sub.subItems && sub.subItems.length > 0) {
              sub.subItems.forEach((item: any) => {
                if (item.buhinEditTotalZn == null) {
                  item.buhinEditTotalZn = item.buhinZn;
                }
                if (item.buhinEditTotalZk == null) {
                  item.buhinEditTotalZk = item.buhinZk;
                }
                if (item.kouchinEditZn == null) {
                  item.kouchinEditZn = item.kouchinZn;
                }
                if (item.kouchinEditZk == null) {
                  item.kouchinEditZk = item.kouchinZk;
                }
                item.totalZk = item.buhinEditTotalZk + item.kouchinEditZk;
                item.totalZn = item.buhinEditTotalZn + item.kouchinEditZn;
              });
            }
          });
        }
      }
    });
  }

  onCloseDialogInspectionCost() {
    this.$refs.estimateInspectionCostComponent.onConfirm();
    this.getJizenMitsumoriPreview();
    this.showDialogInspectionCost = false;
  }

  onCloseDialogCoupon() {
    if ( this.isConfirmCoupon == 0 || this.waitingAutoSaveCoupon == 1 ) {
      this.$refs.quickCouponComponent.onConfirm(1);
    } else {
      // 保存をスキップ
      this.onCloseDialogCouponNext();
    }
  }

  onCloseDialogCouponNext() {
    this.getJizenMitsumoriPreview();
    this.showDialogCoupon = false;
  }

  onShowDialogOption() {
    this.showDialogOption = true;
  }

  onCloseDialogOption() {
    if ( this.isConfirmOption == 0 || this.waitingAutoSaveOption == 1 ) {
      if ( !this.isNextageCustom ) {
        this.$refs.quickOptionComponent.onConfirm(1);
      } else {
        this.$refs.quickOptionComponentNex.onConfirm(1);
      }
    } else {
      // 保存をスキップ
      this.onCloseDialogOptionNext();
    }
  }

  onCloseDialogOptionNext() {
    this.getJizenMitsumoriPreview();
    this.showDialogOption = false;
  }

  onCloseDialogEstimate() {
    this.getJizenInspectionSeibi();
    this.getJizenMitsumoriPreview();
    this.showDialogEstimate = false;
  }

  onShowPrintJizenMitsumori() {
    this.showDialogPreview = true;
  }

  onPrintJizenMitsumori() {
    /** 2022-03-16 sh #7780(BQR807-17) add check ryoukin-rank. [START] */
    if (!this.isValidRyoukinRank()) {
      /** 料金ランクが未設定の場合、印刷させない */
      this.confirmDialogMsg = MESSAGE.InvalidRyoukinRank;
      this.$refs.confirmDialogOnlyClose.onOpen();
      return ;
    }
    /** 2022-03-16 sh #7780(BQR807-17) add check ryoukin-rank. [END] */
    this.loadingService.show();
    this.reqService.getSknEstimate(this.uketsukeExtendsId).then((blob: any) => {
      this.loadingService.hide();
      let link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = this.ippanSeibiService.getIppanSeibiLabel('概算車検見積書') + '.pdf';
      link.click();
    /** 2022-03-16 sh #7780(BQR807-17) add check ryoukin-rank. [START] */
    }, (err: any) => {
      /** ローディングを止める */
      this.loadingService.hide();
      this.$notify.error({
        title: "エラー",
        message: MESSAGE.SystemError
      });
    /** 2022-03-16 sh #7780(BQR807-17) add check ryoukin-rank. [END] */
    });
  }

  onCloseDialogPreview() {
    this.showDialogPreview = false;
  }

  getCompanyInfo() {
    this.reqService.getPrefectures().then(list => {
      this.listPrefectures = list;

      this.reqService.getCompanyInfo().then((res)=> {
        if (res) {
          this.companyInfo = res;

          const pref = this.listPrefectures.filter( (e: any) => e.prefCd == this.companyInfo.prefCd );
          if (pref && pref.length > 0) {
            this.companyInfo.prefNm = pref[0].prefNm;
          }
        }
      }, (err: any) => {
        this.companyInfo = {
          zip1: null,
          zip2: null,
          prefCd: null,
          prefNm: null,
          addr1: null,
          addr2: null,
          shatenNm: null,
          kyotenNm: null,
          tel1: null,
          tel2: null,
          tel3: null,
          lineQr: null
        };
      });
    });
  }

  onRegister() {
    this.$emit("onregister", { pageName: this.$route.name, status: NAVIGATION_STATUS.REGISTER });
  }

  selectionReceiver = this.createSelectionReceiver();

  // Vueに束縛されたメソッド内で生成し、コールバックが実インスタンスを参照するようにする。
  createSelectionReceiver() {
    return new SelectionNotificationReceiver({
      context: () => ({
        request: this.reqService, id: this.uketsukeExtendsId,
        kbn: store.getters["ReservationDetail/sknSeibiShubetsuKbn"] || 0
      }),
      apply: snapshot => this.applySelectionSnapshot(snapshot),
      onError: () => this.$notify.error({ title: "更新エラー", message: "他画面の変更を取得できませんでした。画面を開き直してください。" }),
      beforeCourseRefresh: () => this.reqService.setFreeOfCharge(this.uketsukeExtendsId),
    });
  }


  beforeDestroy() {
    this.selectionReceiver.dispose();
    clearTimeout(this.timeId);
  }

  onSelectionChanged(frame?: any, courseNotification: boolean = false) {
    return this.selectionReceiver.receive(frame && this.utils.getWSData(frame), courseNotification);
  }

  applySelectionSnapshot(snapshot: any) {
    const { detail, option, coupon } = snapshot;
    if (Object.prototype.hasOwnProperty.call(detail, "jizenCd")) {
      store.dispatch("InspectionDetail/setJizenCd", detail.jizenCd);
      store.dispatch("InspectionDetail/setInspectLineCd", detail.inspectLineCd);
    }
    store.dispatch("InspectionDetail/setSeibiMenuCd", detail.shakenShuruiSeibiMenuCd);
    store.dispatch("Option/setOptionFromSocket", option);
    store.dispatch("Coupon/setCouponFromSocket", coupon);
    this.onPayments();
  }

  // モーダルの状況で実行抑制
  execOnPayments() {
    if (!this.showDialogEstimate) {
      this.onPayments();
    }
  }

  /** 2021-08-18 sh #7350 if change estimate at User screen, re-get jizen mitsumori. [START] */
  onPayments() {
    /** 2023-03-30 sh #8188(BQR1084) course does not work for recommend. [START] */
    // this.$notify.info({
    //   title: "Info",
    //   message: MESSAGE.UpdatedJizenEstimate
    // });
    // this.getJizenMitsumoriPreview();
    // this.getJizenResult();
    // this.getJizenInspectionSeibi();
    clearTimeout(this.timeId);
    this.timeId = setTimeout(() => {
      this.$notify.info({
        title: "Info",
        message: MESSAGE.UpdatedJizenEstimate
      });
      this.getJizenMitsumoriPreview();
      this.getJizenResult();
      this.getJizenInspectionSeibi();
    }, 1500);
    /** 2023-03-30 sh #8188(BQR1084) course does not work for recommend. [END] */
  }

  /** 2021-08-18 sh #7350 if change estimate at User screen, re-get jizen mitsumori. [END] */

  /** 2021-08-23 sh #7361 change shakenTotal from referenct to mutation. [START] */
  get shakenTotal() {
    return this.data.calcTotal;
  }
  /** 2021-08-23 sh #7361 change shakenTotal from referenct to mutation. [END] */
  onSave() {
    this.$refs.dialog.onOpen();
  }
  onSubmit() {
      this.reqService.updateSknWorkProgressStateOnHold(this.uketsukeExtendsId).then(
        (res: any) => {
          this.$router.push({ name: "reservation" });
        },
        (err: any) => {
        }
      );
  }
  /** 2021-09-07 sh #7391 implements socket for option and coupon. [START] */
  onUpdateCoupon() {
    const userService = new UserService();
    userService.getCoupon();
  }
  onUpdateOption() {
    const userService = new UserService();
    userService.getOption();
  }
  /** 2021-09-07 sh #7391 implements socket for option and coupon. [END] */

  onConfirmExit() {
    // デザイン統合用のダミー
  }

  onPaymentsBeforeSettimeout(msec: number = 1000) {
    // デザイン統合用のダミー
  }

  isCourseSubItem(item: any) {
    // クイック見積もりと統合するためのダミー
    return "";
  }

  /** 2021-10-05 sh #7438 implements tech info amount. [START] */
  get isUseTechInfoAmount() {
    return this.data.isUseTechInfoAmount == 1;
  }
  /** 2021-10-05 sh #7438 implements tech info amount. [END] */

  /** 2021-10-25 sh #7493 change display of spec. [START] */
  onEndDraggable() {
    setTimeout(() => {
      // console.log("estimateDetail.onEndDraggable seibiList", this.seibiList);
      /** 今の並び順をdisplayOrderに設定しておく。 */
      const saveData = this.seibiList.map((e: any, index: number) => {
        // FE専用の値を削除できないので組みなおす処理に一旦変更する。
        // 元の処理的にはe.displayOrder = index + 1;だけで十分
        let res: any = {
          buhinEditTotalZk              : e.buhinEditTotalZk,
          buhinEditTotalZn              : e.buhinEditTotalZn,
          // buhinList                     : e.buhinList, // FE専用の値を削除する
          // buhinListDisp                 : e.buhinListDisp, // FE専用の値を削除する
          // buhinListLoaded               : e.buhinListLoaded, // FE専用の値を削除する
          buhinZk                       : e.buhinZk,
          buhinZn                       : e.buhinZn,
          displayOrder                  : index + 1, // 0番目だと、ISNULLでNULL判定になる感じなので、+1しておく。
          doTenken                      : e.doTenken,
          inspectResult                 : e.inspectResult,
          inspectValue                  : e.inspectValue,
          isDiscount                    : e.isDiscount,
          isHasMultipleBuhin            : e.isHasMultipleBuhin,
          isHoanKijun                   : e.isHoanKijun,
          isNumber                      : e.isNumber,
          kouchinEditZk                 : e.kouchinEditZk,
          kouchinEditZn                 : e.kouchinEditZn,
          kouchinZk                     : e.kouchinZk,
          kouchinZn                     : e.kouchinZn,
          koukanMeyasuTime              : e.koukanMeyasuTime,
          koumoku                       : e.koumoku,
          kousuu                        : e.kousuu,
          manualExtendsKbn              : e.manualExtendsKbn,
          rowNum                        : e.rowNum,
          sknInspectCategoryId          : e.sknInspectCategoryId,
          sknInspectDescriptionSeibiId  : e.sknInspectDescriptionSeibiId,
          sknInspectId                  : e.sknInspectId,
          sknInspectSeibiDescriptionNm  : e.sknInspectSeibiDescriptionNm,
          sknInspectSeibiId             : e.sknInspectSeibiId,
          sknInspectSubCategoryId       : e.sknInspectSubCategoryId,
          sknInspectType                : e.sknInspectType,
          sknRecommendInspectCategoryId : e.sknRecommendInspectCategoryId,
          sknUketsukeExtendsId          : e.sknUketsukeExtendsId,
          sknUketsukeManualSeibiId      : e.sknUketsukeManualSeibiId
        };
        // return e;
        return res;
      });
      const promise = this.saveJizenDisplayOrderPM(this.uketsukeExtendsId, saveData);

      this.$set(this, "loading", true);
      Promise.all([promise]).then((val: any) => {
        this.getJizenMitsumoriPreview();
        this.$set(this, "loading", false);

      }, (err: any) => {
        this.$set(this, "loading", false);

      });
    }, 1000);
  }

  saveJizenDisplayOrderPM(uketsukeExtendsId: any, data: any) {// 
    const promise = new Promise((resolve, reject) => {
      this.reqService.saveJizenDisplayOrder(uketsukeExtendsId, data).then((res: any) => { // sendSocket:29車検項目の表示順並び替え
        resolve(res);
      }, (err: any) => {
        reject(err);
      });
    });
    return promise;
  }

  isNotRecommend(item: any) {
    return !(item.sknInspectId == null);
  }

  isHoan(item: any) {
    if ( !item.isDiscount && !item.isHoanKijun ) {
      return 0;
    } else if ( item.isDiscount == 1 && item.isHoanKijun ) {
      return 1;
    } else if ( item.isDiscount == 2 ) {　// disAnsewr9 // disAnsewr8
      return 0; // ラベルレス無償
    } else {
      return 2;
    }
  }
  /** 2021-10-25 sh #7493 change display of spec. [END] */
  /** 2022-03-16 sh #7780(BQR807-17) add check ryoukin-rank. [START] */
  isValidRyoukinRank() {
    if (this.reservationDetail.sknUketsukeExtends && !this.reservationDetail.sknUketsukeExtends.ryoukinRankCd) {
      return false;
    }
    return true;
  }
  /** 2022-03-16 sh #7780(BQR807-17) add check ryoukin-rank. [END] */

  /** 2022-11-29 sh #8121(BQR982) get free of charge after change shaken-shurui. [START] */
  onFreeOfChargeBeforeOnPayments() {
    this.$set(this, "loading", true);
    this.reqService.setFreeOfCharge(this.uketsukeExtendsId).then(
      (res: any) => {
        this.$set(this, "loading", false);
        this.onPayments();
      },
      (err: any) => {
        this.$set(this, "loading", false);
      }
    );
  }
  /** 2022-11-29 sh #8121(BQR982) get free of charge after change shaken-shurui. [END] */

  gotoFactoryCustomer() {
    this.reqService.getReservationTarget(this.uketsukeExtendsId,0)
    .then((res: any) => {
      if (res.length > 0) {

        res.forEach((e: any, i: number) => {
          if ( e.uketsukeCd == e.uketsukeParentCd || e.uketsukeParentCd == "") {
            this.$router.push({
              name: "customer",
              params: { code: e.uketsukeCd }
            });
          }
        });
        
      }
    });
  }

  get rightBoxSize() {
    return this.isEstimateBuhin?'w120':'w160';
  }

  async getExtendsImageInspectMap() {
    if (!this.isCanExtendsImage) {
      return;
    }
    if (!this.isUserMode) {
      this.extendsImageInspectMap = await this.extendsImageService.getExtendsImageInspectMap();
      this.extendsImageService.connectSocket(this.extendsImageSocketCallback, this.sktControll);
    }
  }
  extendsImageSocketCallback(updatedList: ExtendsImageInspectVO[]) {
    if (updatedList[0].carImageMenuId) {
      return;
    }
    this.$message({
      message: MESSAGE.UpdatedImage,
      type: "info",
      duration: 700,
      customClass: "msg-center shadow",
      showClose: true
    });
    if (!this.extendsImageInspectMap) {
      this.extendsImageInspectMap = {};
    }
    this.extendsImageInspectMap[updatedList[0].sknUketsukeInspectId!] = updatedList[0];
    this.updateExtendsImageWorkList();
  }
  isShowImageButton(item: any): boolean {
    return !this.isModeTab &&
      this.isCanExtendsImage &&
      this.isNotRecommend(item) &&
      item.manualExtendsKbn != 2;  // 先頭のコース料金以外
  }
  hasImage(item: any): boolean {
    return !!(
      this.isCanExtendsImage &&
      this.extendsImageInspectMap &&
      this.extendsImageInspectMap[item.sknInspectId] &&
      this.extendsImageInspectMap[item.sknInspectId].imageList &&
      this.extendsImageInspectMap[item.sknInspectId].imageList!.length
    );
  }
  updateExtendsImageWorkList(sknInspectSeibiId: any = null, sknUketsukeManualSeibiId: any = null) {
    this.extendsImageWorkList = [];
    if (!this.extendsImageInspectMap) {
      return;
    }
    for (const item of this.seibiList) {
      if (!this.isShowImageButton(item)) {
        continue;
      }
      const work = this.utils.deepCopy(this.extendsImageInspectMap[item.sknInspectId]);
      work.label += `(${item.sknInspectSeibiDescriptionNm})`;
      this.extendsImageWorkList.push(work);
      // この画面のseibiList内の要素はsknInspectSeibiIdとsknUketsukeManualSeibiIdで特定可能
      if ((sknInspectSeibiId && sknInspectSeibiId == item.sknInspectSeibiId) 
      || (sknUketsukeManualSeibiId && sknUketsukeManualSeibiId == item.sknUketsukeManualSeibiId)) {
        this.extendsImageWorkListIndex = this.extendsImageWorkList.length - 1;
      }
    }
  }
  openExtendsImageDialog(item: any) {
    if (!this.extendsImageInspectMap) {
      this.$notify.error({
        title: "エラー",
        message: MESSAGE.SystemError
      });
      window.console.error('openExtendsImageDialog: extendsImageInspectMapが空');
      return;
    }
    this.updateExtendsImageWorkList(item.sknInspectSeibiId, item.sknUketsukeManualSeibiId);
    this.showExtendsImageDialog = true;
  }

  // WorkOrderのextremeへの取込準備を事前見積段階で行う
  // getData(isFirstGet: boolean = false) {
  getDataVersionEstimate() {
    this.$set(this, "loading", true);
    this.reqService
      .getAssignmentWork(this.uketsukeExtendsId)
      .then((res: any) => {
        if (res) {
          const items = this.inspectService.filterWorkOrder(res.items);
          const manualItems = this.inspectService.filterWorkOrder(
            res.manualItems
          );
          this.$set(this, "workData", { ...res, items, manualItems });
          this.$nextTick(() => {
          //  const req = new requestService();
            const data = {
              sknUketsukeExtendsId: this.uketsukeExtendsId,
              uketsukeCd: this.uketsukeCd,
              yoyakuNo: this.yoyakuNo
              , currentWorkProgressState: 14
            };
            this.reqService.saveCompleted(data).then(res2 => { // sendSocket:32車検中止
          //    this.$refs.subHeader.getSubHeaderData();
              this.saveDataVersionEstimate(1); // 実行後車検終了
            });
            
          });

          
        //  if (this.workData.items) {
        //  //  this.workItem = this.workData.items;
        //    if (
        //      this.workData.manualItems &&
        //      this.workData.manualItems.length > 0
        //    ) {
        //  //    this.workItem = this.workItem.concat(this.workData.manualItems);
        //    }
// 
        //  //  this.checkComplete();
        //  //  if (isFirstGet && res.seibiNotSelect) {
        //  //    this.errorMsg = MESSAGE.SeibiNotSelectDotenken;
        //  //    this.$refs.errorDialog.onOpen();
        //  //  }
        //    // console.log('workData', JSON.parse(JSON.stringify(this.workData)));
        //  // } else {
        //  //  this.disabledSave = false;
        //  }
        }
        this.$set(this, "loading", false);
        this.$notify.info({
          title: "Info",
          message: MESSAGE.SaveEstimateAssignment
        });
      });
  }

  // WorkOrderのextremeへの取込準備を事前見積段階で行う
  // saveData(btn: number) {
  saveDataVersionEstimate(btn: number) {
    this.workData.btnAction = btn;
    if (this.workData.items == null) {
      this.workData.items = [];
    }
    if (this.workData.manualItems == null) {
      this.workData.manualItems = [];
    }
    return this.reqService.saveAssignmentWork(this.workData);
  }
}
